import React, {useEffect, useState} from "react";
import axios from "axios";
import "../styles/CourseDetailsForm.css";

export default function CourseDetailsForm() {
    const [courses, setCourses] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState("");


    const [form, setForm] = useState({
        introduction: "",
        objective: "",
        targetAudience: "",
        reasonsToJoin: "",
        learningOutcomes: ""
    });

    // Kursları çek
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/courses`)
            .then(res => setCourses(res.data))
            .catch(err => console.error("Kurslar alınamadı:", err));
    }, []);


    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...form,
            courseId: selectedCourseId
        };


        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/courses/${selectedCourseId}/details`, payload);
            alert("Başarıyla kaydedildi.");
        } catch (err) {
            alert("Kaydetme sırasında bir hata oluştu.");
        }
    };

    return (
        <form className="course-details-form" onSubmit={handleSubmit}
              style={{maxWidth: 800, margin: "auto", padding: "1rem"}}>
            <h2>Kurs Detayları</h2>

            <label>Kurs Seçin</label>
            <select
                className="course-select"
                value={selectedCourseId}
                onChange={(e) => setSelectedCourseId(e.target.value)}
                required
                style={{width: "100%", marginBottom: "1rem"}}
            >
                <option value="">Bir kurs seçin</option>
                {courses.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                ))}
            </select>

            {selectedCourseId && (
                <>
                    <label>Tanıtım</label>
                    <textarea className="course-textarea" name="introduction" value={form.introduction}
                              onChange={handleChange} rows={4}/>

                    <label>Eğitim Hedefi</label>
                    <textarea className="course-textarea" name="objective" value={form.objective}
                              onChange={handleChange} rows={3}/>

                    <label>Hedef Kitle</label>
                    <textarea className="course-textarea" name="targetAudience" value={form.targetAudience}
                              onChange={handleChange} rows={3}/>

                    <label>Neden Katılmalısınız?</label>
                    <textarea className="course-textarea" name="reasonsToJoin" value={form.reasonsToJoin}
                              onChange={handleChange} rows={3}/>

                    <label>Öğrenme Çıktıları</label>
                    <textarea className="course-textarea" name="learningOutcomes" value={form.learningOutcomes}
                              onChange={handleChange} rows={4}/>

                    <button className="course-details-btn" type="submit" style={{marginTop: "1rem"}}>Kaydet</button>
                </>
            )}
        </form>
    );
}
